import React from 'react';

const MetalRoofIcon = ({ active }) => {
    return (
        <img
            alt='Metal Roof'
            src={
                active
                    ? '/assets/metalroof-tab-active.svg'
                    : '/assets/metalroof-tab-inactive.svg'
            }
        />
    );
};

export default MetalRoofIcon;
